import {ClientPlacement} from './clientPlacement.model';

export class ClientDiagnosis {
    id: string;
    diagnosisId: number;
    diagnosisCode: string;
    diagnosisDescription: string;
    diagnosisExternalId: string;
    date: string;
    externalId: string;
    primary: boolean;
    placement: ClientPlacement;

    constructor(clientDiagnosis: any) {
        if (clientDiagnosis) {
            this.id = clientDiagnosis.id;
            this.diagnosisId = clientDiagnosis.diagnosisId;
            this.diagnosisCode = clientDiagnosis.diagnosisCode;
            this.diagnosisDescription = clientDiagnosis.diagnosisDescription;
            this.diagnosisExternalId = clientDiagnosis.diagnosisExternalId;
            this.date = clientDiagnosis.date;
            this.externalId = clientDiagnosis.externalId;
            this.primary = clientDiagnosis.primary;
            this.placement = new ClientPlacement(clientDiagnosis.placement);
        }
    }
}
